import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Tooltip,
  Typography,
  useTheme,
  IconButton,
} from "@mui/material";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IProposerList } from "src/Types/module/UpdateRequest/RequestProposerInfo";
import { getStatusLabel } from "src/Utils/Combined";

interface IProps {
  isLoading: boolean;
  proposerInfo: IProposerList[];
}

const ProposerIndex = ({ isLoading, proposerInfo }: IProps) => {
  const theme = useTheme();
  return (
    <>
      {" "}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Company Name</TableCell>
              <TableCell>Representative Name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableLoader />
            ) : proposerInfo.length ? (
              <>
                {proposerInfo.map((sProposerInfo) => {
                  return (
                    <TableRow hover key={sProposerInfo.request_id}>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sProposerInfo.request_id}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {sProposerInfo.proposer_request_to_company_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="body1"
                          color="text.primary"
                          gutterBottom
                          noWrap
                        >
                          {
                            sProposerInfo.proposer_request_to_representative_name
                          }
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {getStatusLabel(sProposerInfo.status)}
                      </TableCell>
                      <TableCell>
                        <Link
                          to={`/update-request/proposer-info/${sProposerInfo.request_id}?memberid=${sProposerInfo.proposer_request_from}`}
                        >
                          <Tooltip title="View" arrow={true}>
                            <IconButton
                              sx={{
                                "&:hover": {
                                  background: theme.colors.primary.lighter,
                                },
                                color: theme.palette.primary.main,
                              }}
                              color="inherit"
                              size="small"
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Link>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <TableNotFound />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ProposerIndex;
